module.exports = __webpack_public_path__ + "img/con_1.ece7be3a.svg";